import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();
  const features = [
    { icon: 'ri-fire-line', label: t('about.f1') },
    { icon: 'ri-restaurant-line', label: t('about.f2') },
    { icon: 'ri-bike-line', label: t('about.f3') },
    { icon: 'ri-star-smile-line', label: t('about.f4') },
  ];

  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 md:px-6 lg:grid-cols-2">
        <div className="relative">
          <div className="relative overflow-hidden rounded-lg">
            <img
              src="https://public.readdy.ai/ai/img_res/edited_e4ce0d71739b3b3a71e5a9bcce4d784e_24d94b6b.jpg"
              alt="Inder, owner of Mehfil 24/7"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 hidden rounded-lg bg-accent-500 px-7 py-5 text-center md:block">
            <p className="font-heading text-3xl font-semibold text-background-50">{t('about.badgeV')}</p>
            <p className="mt-1 text-xs tracking-wide text-background-50/90">{t('about.badgeL')}</p>
          </div>
        </div>

        <div>
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.3em] uppercase text-primary-600">
            <span className="h-px w-8 bg-primary-500"></span>
            {t('about.eyebrow')}
          </span>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight text-foreground-950 md:text-4xl">
            {t('about.title')}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-700">
            {t('about.p1')}
          </p>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            {t('about.p2')}
          </p>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            {t('about.owner')}
          </p>

          <ul className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {features.map((item) => (
              <li
                key={item.label}
                className="flex items-center gap-3 rounded-lg bg-background-100 px-4 py-3"
              >
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800">{item.label}</span>
              </li>
            ))}
          </ul>

          <a
            href="#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            {t('about.cta')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}